import React, { Component } from 'react';
import styled from 'styled-components';
import { map } from 'ramda';
import { Section } from '../../common';
import TeamIcon from '../../../assets/iconsSet/TeamIcon';
import ChartIcon from '../../../assets/iconsSet/ChartIcon';
import HomeIcon from '../../../assets/iconsSet/HomeIcon';
import RocketIcon from '../../../assets/iconsSet/RocketIcon';

const icons = {
  teamIcon: <TeamIcon />,
  rocketIcon: <RocketIcon />,
  chartIcon: <ChartIcon />,
  homeIcon: <HomeIcon />,
};

const Feature = ({ title, icon, description }) => (
  <FeatureWrapper>
    {icons[icon]}
    <PrimaryFeatureLine>{title}</PrimaryFeatureLine>
    <SecondaryFeatureLine>{description}</SecondaryFeatureLine>
  </FeatureWrapper>
);

const PrimaryFeatureLine = styled.div`
  font-weight: bold;
  color: #475059;
`;

const SecondaryFeatureLine = styled.div`
  color: #8E9AA7;
`;

const FeatureWrapper = styled.div`
  display: flex;
  flex: auto;
  width: 120px;
  align-items: center;
  flex-direction: column;
  text-align: center;
  font-size: 14px;

  & > *:not(:last-child) {
    margin-bottom: 8px;
    margin-rigth: 16px;
  }
`;

export default class Features extends Component {
  render() {
    const { features } = this.props;

    return (
      <BackgroundColor>
        <FeaturesSection>
          {map(feature => <Feature key={feature.title} {...feature} />)(features)}
        </FeaturesSection>
      </BackgroundColor>
    );
  }
}

const FeaturesSection = styled(Section)`
  justify-content: space-between;
  display: flex;
  padding: 32px 0;
  max-width: 700px;
  flex-wrap: wrap;
`;

const BackgroundColor = styled.div`
  border-top: 2px solid #f2f5f7;
`;
